export const ButtonMoreComponent = {
  templateUrl: 'components/Buttons/button-more/button-more.html',
  controller: function ButtonMoreController(localizationService) {
    'ngInject';
    this.isRTLNeeded = localizationService.shouldActivateRTL();
  },
};
